import { render, staticRenderFns } from "./PdpVariantSelector.vue?vue&type=template&id=466104f6&scoped=true&"
import script from "./PdpVariantSelector.vue?vue&type=script&lang=js&"
export * from "./PdpVariantSelector.vue?vue&type=script&lang=js&"
import style0 from "./PdpVariantSelector.vue?vue&type=style&index=0&id=466104f6&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466104f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppInfoModal: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppInfoModal.vue').default,AppSelectBox: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppSelectBox.vue').default})
